import { p as proxyCustomElement, H, h, c as Host } from './p-DUAwwEEc.js';
import { d as defineCustomElement$1 } from './p-BVcGBUOP.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.4.1
 */

const TdsSidenavPopover = /*@__PURE__*/ proxyCustomElement(class TdsSidenavPopover extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Maximum screen width at which the popover will be displayed
         */
        this.popoverMaxScreenWidth = "720px";
        // --------------------------------------------------------------------------
        //
        //  Private Methods
        //
        // --------------------------------------------------------------------------
        this.handleResize = () => {
            const maxWidth = parseInt(this.popoverMaxScreenWidth);
            const windowWidth = window.innerWidth;
            if (windowWidth < maxWidth) {
                this.popoverRef.setAttribute("popover", "auto");
            }
            else {
                this.popoverRef.removeAttribute("popover");
            }
        };
        this.removeResizeObserver = () => {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        };
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentWillLoad() {
        var _a;
        const parentNavId = (_a = this.el.closest("nav")) === null || _a === void 0 ? void 0 : _a.id;
        if (!parentNavId) {
            throw new Error("Sidenav popover must be a child of a nav element");
        }
        this.popoverId = `${parentNavId}-popover`;
    }
    componentDidLoad() {
        this.resizeObserver = new ResizeObserver(() => {
            this.handleResize();
        });
        this.resizeObserver.observe(document.body);
    }
    disconnectedCallback() {
        this.removeResizeObserver();
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '178274cad351fb6d380ac041efb7fa47dfd007c8' }, h("tds-popover-container", { key: '6ccdc50d9336d6c62d4f9eec9261625966671112', id: this.popoverId, class: "tds-sidenav-collapse", autoPosition: true, ref: (e) => (this.popoverRef = e) }, h("div", { key: 'd074cc2da0caeb2fb4458eefbd6354c7b551e5f5', class: "tds-sidenav-scroll-container" }, h("slot", { key: '5e2adabdecaa991914f7a6b0e060b03c30509a90' })))));
    }
    get el() { return this; }
}, [6, "tds-sidenav-popover", {
        "popoverMaxScreenWidth": [1, "popover-max-screen-width"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-popover", "tds-popover-container"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-popover":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TdsSidenavPopover);
            }
            break;
        case "tds-popover-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { TdsSidenavPopover as T, defineCustomElement as d };
//# sourceMappingURL=p-eFHPLBHY.js.map
